export default [
  { value: 'bachata', label: 'Bachata' },
  { value: 'salsa', label: 'Salsa' },
  { value: 'merengue', label: 'Merengue' },
  { value: 'cha cha', label: 'Cha cha' },
  { value: 'kizomba', label: 'Kizomba' },
  { value: 'tango', label: 'Tango' }
];
